import { cloneDeep, defaultsDeep, merge, pick } from 'lodash'

import { empty } from '@sigma-frontend-libs/commons'
import { SENDINGS_FALLBACKS_OPTIONS_CLEAN, SENDINGS_FALLBACKS_OPTIONS_DEFAULT } from '@sigma-legacy-libs/essentials/lib/constants'

export const getEmptyFallback = () => {
  return defaultsDeep(
    pick(cloneDeep(empty.sendings.create), [ 'type', 'payload' ]),
    { $options: merge({}, cloneDeep(SENDINGS_FALLBACKS_OPTIONS_CLEAN), cloneDeep(SENDINGS_FALLBACKS_OPTIONS_DEFAULT)) }
  )
}
